import { cellStatus } from "@/features/data-curation/cellStatus";
import { SearchNoteBody } from "@/features/data-curation/components/SearchNote";
import { StatusBadge } from "@/features/data-curation/components/StatusBadge";
import type { CurationColumn, ExtractionRow } from "@/features/data-curation/types";

/** For each column of a row: the status of its value, where a search found nothing, or empty. */
export const SearchReport = ({
  row,
  columns,
}: {
  row: ExtractionRow;
  columns: CurationColumn[];
}) => {
  const cells = new Map(row.cells.map((cell) => [cell.column_id, cell]));
  return (
    <section aria-labelledby="row-search-report" className="space-y-2">
      <h3 id="row-search-report" className="text-sm font-medium text-zinc-900">
        Search report
      </h3>
      <p className="text-xs text-zinc-500">
        Not found means a search found nothing. Empty means no one has searched yet.
      </p>
      <ul className="divide-y divide-zinc-100 rounded-[3px] border border-zinc-200">
        {columns.map((column) => {
          const cell = cells.get(column.column_id);
          const note = row.search_notes?.[column.column_id];
          return (
            <li key={column.column_id} className="space-y-1.5 px-3 py-2">
              <div className="flex items-start justify-between gap-3">
                <span className="min-w-0 break-words text-sm font-medium text-zinc-800">
                  {column.label}
                </span>
                {cell && cell.value != null ? (
                  <StatusBadge status={cellStatus(cell)} />
                ) : (
                  <span className="shrink-0 text-xs font-medium text-zinc-500">
                    {note ? "Not found" : "Empty"}
                  </span>
                )}
              </div>
              {(!cell || cell.value == null) && note && <SearchNoteBody note={note} />}
            </li>
          );
        })}
      </ul>
    </section>
  );
};
